import { Component } from '@angular/core';

@Component({
  selector: 'app-base-criteria',
  templateUrl: './base-criteria.component.html',
  styleUrl: './base-criteria.component.scss'
})

export class BaseCriteriaComponent {
  showCriteria = false;
  constructor(){

  }
  showData() {
    this.showCriteria = !this.showCriteria;
  }
  
}
